
import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";
import MegaMenu from "../Megamenu/MegaMenu";
import logo from "../Assets/Frontend_Assets/LOGO1.png";
import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
import user_icon from "../Assets/Frontend_Assets/people.png";
import { ShopContext } from "../../Context/ShopContext";

export const Navbar = () => {
  const { getTotalCartItems } = useContext(ShopContext);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMega, setActiveMega] = useState(null); // Desktop hover
  const [mobileMega, setMobileMega] = useState(null); // Mobile toggle
  const [userOpen, setUserOpen] = useState(false);

  const isLoggedIn = localStorage.getItem("auth-token");
  const isMobile = window.innerWidth <= 991;

  const logoutHandler = () => {
    localStorage.removeItem("auth-token");
    window.location.replace("/");
  };

  /* Prevent background scroll when menu open */
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
  }, [mobileMenuOpen]);

  /* Close mobile menu when window resized to desktop */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setMobileMenuOpen(false);
        setMobileMega(null);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* Helper to handle link click in mobile */
  const handleMobileLinkClick = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
      setMobileMega(null);
    }
  };

  return (
   <div>
    <div className="banner">
  <div className="banner-track">
    <p>🔥 Big Sale - Flat 50% OFF | Free Delivery | New Arrivals 🔥</p>
  </div>
</div>
    <nav className="navbar">
     {/* HAMBURGER */}
        <div
          className="mobile-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      {/* LOGO */}
      <div className="nav-logo">
        <NavLink to="/" className="logo-link" onClick={handleMobileLinkClick}>
          <img src={logo} alt="Khan Collections" />
        </NavLink>
      </div>

      {/* MENU */}
      <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
        {/* SHOP */}
        <li>
          <NavLink to="/" end className="nav-link" onClick={handleMobileLinkClick}>
            Shop
          </NavLink>
        </li>

        {/* MEN */}
        <li
          className="nav-item-with-mega d-view"
          onMouseEnter={() => !isMobile && setActiveMega("men")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/men"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Men
            </NavLink>

            {/* {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "men" ? null : "men")
                }
              >
                {mobileMega === "men" ? "−" : "+"}
              </span>
            )} */}
          </div>

          <MegaMenu
            mainCategory="men"
            show={isMobile ? mobileMega === "men" : activeMega === "men"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>

        {/* WOMEN */}
        <li
          className="nav-item-with-mega d-view"
          onMouseEnter={() => !isMobile && setActiveMega("women")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/women"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Women
            </NavLink>

            {/* {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "women" ? null : "women")
                }
              >
                {mobileMega === "women" ? "−" : "+"}
              </span>
            )} */}
          </div>

          <MegaMenu
            mainCategory="women"
            show={isMobile ? mobileMega === "women" : activeMega === "women"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>

        {/* KIDS */}
        <li
          className="nav-item-with-mega d-view"
          onMouseEnter={() => !isMobile && setActiveMega("kids")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/kids"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Kids
            </NavLink>

            {/* {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "kids" ? null : "kids")
                }
              >
                {mobileMega === "kids" ? "−" : "+"}
              </span>
            )} */}
          </div>

          <MegaMenu
            mainCategory="kids"
            show={isMobile ? mobileMega === "kids" : activeMega === "kids"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>
          <li className="mobile-only">
          <NavLink to="/men"  className="nav-link" onClick={handleMobileLinkClick}>
           Men Footwear
          </NavLink>
        </li>
          <li className="mobile-only">
          <NavLink to="/women"  className="nav-link" onClick={handleMobileLinkClick}>
            Women Footwear
          </NavLink>
        </li>
          <li className="mobile-only">
          <NavLink to="/kids"  className="nav-link" onClick={handleMobileLinkClick} >
            Kids Footwear
          </NavLink>
        </li>
         <li className="mobile-only">
          <NavLink to="/category/men/accessories/Wallets"  className="nav-link" onClick={handleMobileLinkClick}>
            Wallet
          </NavLink>
        </li>
         <li className="mobile-only">
          <NavLink to="/category/men/accessories/Watches"  className="nav-link" onClick={handleMobileLinkClick}>
            Watches
          </NavLink>
        </li>
         <li className="mobile-only">
          <NavLink to="/category/men/accessories"  className="nav-link" onClick={handleMobileLinkClick}>
            Accesories
          </NavLink>
        </li>
      </ul>

      {/* RIGHT SIDE */}
      <div className="hambicon">
        <div className="nav-icons">
          {/* USER */}
          <div
            className="user-dropdown"
            onMouseEnter={() => setUserOpen(true)}
            onMouseLeave={() => setUserOpen(false)}
            onClick={() => setUserOpen(!userOpen)}
          >
            <img src={user_icon} alt="user" className="user-icon" />

            <div className={`user-menu ${userOpen ? "show" : ""}`}>
              {!isLoggedIn && <NavLink to="/login">Login</NavLink>}

              {isLoggedIn && (
                <>
                  <NavLink to="/my-orders">My Orders</NavLink>
                  <button onClick={logoutHandler}>Logout</button>
                </>
              )}
            </div>
          </div>

          {/* CART */}
          <NavLink to="/cart" className="cart-icon">
            <img src={cart_icon} alt="cart" />
            <span className="nav-cart-count">{getTotalCartItems()}</span>
          </NavLink>
        </div>

       
      </div>
    </nav>
    </div>
  );
};

export default Navbar;
